export default __webpack_public_path__ + "static/media/fruit_poster.852127bd.jpg";